<template>
  <header v-if="!isSymposium">
    <div class="s">
      <button
        type="button"
        class="menu-btn-s"
        aria-label="เปิดเมนูหลัก"
        aria-controls="mobile-navigation"
        :aria-expanded="isNavOpen.toString()"
        ref="menuButton"
        @click.prevent="showNav()"
      ></button>

      <div
        id="mobile-navigation"
        :style="styleNavLg"
        :aria-hidden="(!isNavOpen).toString()"
        :inert="!isNavOpen ? 'inert' : null"
        class="overlay"
      >
        <div class="box-btn">
          <img src="../../assets/images/admans_logo.png" width="521" height="135" alt="Adman Awards" loading="lazy" decoding="async" />
          <button
            type="button"
            class="close-btn"
            aria-label="ปิดเมนูหลัก"
            ref="closeButton"
            @click.prevent="closeNav()"
          ></button>
        </div>
        <nav class="box-link">
          <div
            v-for="(menu, i) in menusx"
            :key="i"
            :class="[menu.active ? 'router-link-exact-active' : '']"
            class="section-link"
          >
            <!-- <router-link :to="menu.route">
              {{ menu.title }}
            </router-link>-->
            <div
              @click="showSubArchives = !showSubArchives"
              v-if="menu.title.toLowerCase() === 'archives'"
              :style="showSubArchives ? { height: '100%' } : {}"
            >
              <span>Archives</span>
              <div
                class="sub-archive-small"
                :class="showSubArchives ? 'sub-archive-small--open' : ''"
              >
                <template v-for="(sub, subIndex) in menu.subs">
                  <a
                    v-if="sub.routeName === 'WinnerArchive20172019'"
                    :key="subIndex"
                    href="https://archive.admanawards.com/"
                    target="_blank"
                    >{{ sub.title }}</a
                  >

                  <router-link
                    v-else
                    :key="'B1' + subIndex"
                    :to="{ name: sub.routeName }"
                    >{{ sub.title }}</router-link
                  >
                </template>
                <!-- <router-link
                  v-for="(sub, subIndex) in menu.subs"
                  :key="subIndex"
                  :to="{ name: sub.routeName }"
                >
                  {{ sub.title }}
                </router-link>-->
              </div>
            </div>

            <router-link
              v-else
              :to="menu.route"
              :class="[menu.active ? 'router-link-exact-active' : '']"
              >{{ menu.title }}</router-link
            >
          </div>
        </nav>
      </div>
    </div>

    <div class="m">
      <b-container class="first">
        <nav class="left">
          <div
            v-for="(menu, i) in menusx"
            :key="i"
            :to="menu.route"
            class="section"
            :class="[menu.active ? 'router-link-exact-active' : '']"
          >
            <!-- <router-link :to="menu.route">
              {{ menu.title }}
            </router-link>-->
            <div
              @click="showSubArchives = !showSubArchives"
              v-if="menu.title.toLowerCase() === 'archives'"
              style="cursor: pointer; width: 100%; height: 100%"
              :style="showSubArchives ? { background: '#DA0401' } : {}"
            >
              <span :style="showSubArchives ? { color: '#F1F2F2' } : {}"
                >Archives</span
              >
              <div
                v-if="showSubArchives"
                @mouseleave="showSubArchives = false"
                class="sub-archive-medium"
                :class="showSubArchives ? '' : ''"
              >
                <template v-for="(sub, subIndex) in menu.subs">
                  <a
                    v-if="sub.routeName === 'WinnerArchive20172019'"
                    :key="subIndex"
                    href="https://archive.admanawards.com/"
                    target="_blank"
                    >{{ sub.title }}</a
                  >

                  <router-link
                    v-else
                    :key="'B2' + subIndex"
                    :to="{ name: sub.routeName }"
                    >{{ sub.title }}</router-link
                  >
                </template>
              </div>
            </div>

            <router-link v-else :to="menu.route">{{ menu.title }}</router-link>
          </div>
        </nav>
      </b-container>
      <!-- Nomarl -->
      <div v-if="false" class="right">
        <div class="box-search">
          <input type="text" placeholder="Search" />
          <button></button>
        </div>
        <div class="box-icon">
          <img src="../../assets/images/user-icon.png" width="500" height="343" alt="User" />
        </div>
        <div class="user-btn">
          <button @click="clickLogin()">USER LOGIN</button>
        </div>
      </div>

      <!-- Calendar -->
      <div v-if="isCalendar" class="right box-calendar">
        <div class="box-search">
          <p>Creativity Day 2023</p>
        </div>

        <div class="box-icon">
          <img src="../../assets/icons/ic-calendar.png" width="96" height="65" alt="" aria-hidden="true" />
          <p>06 November 2019</p>
        </div>

        <div title="Add to Calendar" class="addeventatc add-calendar">
          <span class="client">abKiFTOwhzsuRNYVAmhK73953</span>
          <div>Add to Calendar</div>
          <span class="start">06-11-2019 09:00</span>
          <span class="end">06-11-2019 22:00</span>
          <span class="title">Creativity Day 2019</span>
          <span class="description">
            “วันความคิดสร้างสรรค์แห่งชาติ 2023” ช่วงเช้าถึงเย็น รูปแบบงานคืองาน
            Talks, School of Creativity & Exhibition ซึ่งเป็นงานของคนไทยทุกคน
            ที่เห็นคุณค่าของความคิดสร้างสรรค์
            และช่วงค่ำจะมีกิจกรรมพิเศษของคนในวงการโฆษณาและผู้มีส่วนเกี่ยวข้องร่วมฉลองความสำเร็จในงานพิธีประกาศผลประกวดรางวัล
            Adman Awards 2019
          </span>
          <span class="location"
            >สามย่านมิตรทาวน์ฮอลล์ ชั้น5 ศูนย์การค้าสามย่านมิตรทาวน์</span
          >
          <!-- <p class="atc_node">“วันความคิดสร้างสรรค์แห่งชาติ 2019”

            </p>
            <p class="atc_node">ช่วงเช้าถึงเย็น รูปแบบงานคืองาน Talks, School of Creativity &amp; Exhibition ซึ่งเป็นงานของคนไทยทุกคน ที่เห็นคุณค่าของความคิดสร้างสรรค์</p>
            <p class="atc_node">งานของคนที่ชอบอวด(ดี) อวดไอเดียดีๆ อวดความคิดดีๆ ที่มาจากผู้คนหลากวงการ ทั้งสายโฆษณาสายบันเทิง สายออกแบบหรือดีไซน์ หรือแม้กระทั่งสายประชาชนคนธรรมดา </p>
            <p class="atc_node">แต่ไอเดียกระฉูดพร้อมฉุดธุรกิจ หรือองค์กร หรือชุมชนของพวกเขาให้โดดเด่นเป็นที่ยอมรับ งานที่ไม่ว่าคุณจะเป็นใคร ทำอาชีพอะไร </p>
            <p class="atc_node">อยู่ในวงการไหน หากเชื่อในพลังของความคิดสร้างสรรค์ นี่คือวันที่คุณจะค้นพบแรงบันดาลใจ และงานที่จะจุดประกาย ความคิดสร้างสรรค์ให้คุณอีกครั้ง </p>
            <p class="atc_node">
              และช่วงค่ำจะมีกิจกรรมพิเศษของคนในวงการโฆษณาและผู้มีส่วนเกี่ยวข้องร่วมฉลองความสำเร็จในงานพิธีประกาศผลประกวดรางวัล
              Adman Awards 2019
          </p>-->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  data () {
    return {
      isCalendar: false,
      menus: [
        {
          title: 'Home',
          route: {
            name: 'home'
          },
          isDisplay: true
        },
        {
          title: 'About',
          route: {
            name: 'about'
          },
          isDisplay: true
        },
        {
          title: 'Awards',
          route: {
            name: 'awards'
          },
          active: false,
          isDisplay: false
        },
        {
          title: 'Symposium',
          route: {
            name: 'creativity_program'
          },
          active: false,
          isDisplay: false
        },
        {
          title: 'Winners',
          route: {
            name: 'winners'
          },
          active: false,
          isDisplay: false
        },
        {
          title: 'Archives',
          route: {
            name: 'archive'
          },
          subs: [
            {
              title: 'Winner Archive 2021 - 2017',
              routeName: 'WinnerArchive20172019'
            },
            {
              title: 'Winner Archive 2016 - 2004',
              routeName: 'winnerArchive'
              // routeName: 'archive'
            }
            // {
            //   title: 'Program Archive',
            //   routeName: 'programArchive'
            // }
          ],
          active: false,
          isDisplay: true
        },
        {
          title: 'News',
          route: {
            name: 'news'
          },
          active: false,
          isDisplay: true
        },
        {
          title: 'Gallery',
          route: {
            name: 'gallery'
          },
          active: false,
          isDisplay: true
        },
        {
          title: 'Contact',
          route: {
            name: 'contact'
          },
          active: false,
          isDisplay: false
        }
      ],
      routeName: '',
      styleNavLg: {
        padding: '0',
        height: '0'
      },
      showSubArchives: false,
      isNavOpen: false
    }
  },

  watch: {
    $route () {
      this.changeActive()
      // DEMO //
      if (this.$route.name === '_calendar') {
        this.isCalendar = true
      }
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      isSymposium: state => state.symposium.isSymposium
    }),

    menusx () {
      return this.menus
        .map(menu => {
          const mConfig = this.configMap.get(menu.route.name)

          if (menu.route.name === 'contact') {
            menu.isDisplay = Boolean(
              mConfig && mConfig.isActive && mConfig.isDisplay
            )
          } else if (mConfig) {
            menu.isDisplay = mConfig.isDisplay
          }

          if (menu.route.name === 'archive') {
            menu.subs = menu.subs.map((sb) => {
              if (sb.routeName === 'WinnerArchive20172019') {
                const sConfig = this.configMap.get('WinnerArchive20172019')
                if (sConfig) {
                  sb.title = sConfig.name
                }
              }
              return sb
            })
          }
          return menu
        })
        .filter(menu => menu.isDisplay)
    }
  },

  created () {
    this.changeActive()

    if (this.$route.name === '_calendar') {
      this.isCalendar = true
    }
  },

  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    manualActive (index, cond) {
      this.menusx.forEach((menu, i) => {
        if (i === index) {
          menu.active = cond
        }
      })
    },

    checkRouuteName () {
      this.routeName = this.$route.name
    },

    showNav () {
      this.isNavOpen = true
      this.styleNavLg.padding = '16px'
      this.styleNavLg.height = '100vh'
      this.$nextTick(() => {
        if (this.$refs.closeButton) this.$refs.closeButton.focus()
      })
    },

    closeNav () {
      const wasOpen = this.isNavOpen
      this.isNavOpen = false
      this.styleNavLg.padding = '0'
      this.styleNavLg.height = '0'
      if (wasOpen) {
        this.$nextTick(() => {
          if (this.$refs.menuButton) this.$refs.menuButton.focus()
        })
      }
    },

    handleKeydown (event) {
      if (event.key === 'Escape' && this.isNavOpen) {
        this.closeNav()
      }
    },

    // clickLogin () {
    //   window.open('https://online-submission.admanawards.com/login')
    // },

    changeActive () {
      const awardRoutes = ['awards']
      const awardsIndex = this.menusx.findIndex(m => m.route.name === 'awards')
      this.manualActive(awardsIndex, awardRoutes.includes(this.$route.name))

      const creativityRoutes = [
        // 'creativity_program',
        'creativity_talk_symposium',
        'creativity_talk_symposium_detail',
        'creativity_school_of_creativity',
        'creativity_school_of_creativity_time',
        'creativity_school_of_creativity_detail'
      ]
      const creativityIndex = this.menusx.findIndex(
        m => m.route.name === 'creativity_program'
      )
      this.manualActive(
        creativityIndex,
        creativityRoutes.includes(this.$route.name)
      )

      const winnerArchiveRoutes = [
        'winnerArchive',
        'winnerArchiveCategory',
        'winnerArchiveDetail',
        'programArchive',
        'programArchiveCategory',
        'programArchiveDetail'
      ]
      const winnerArchiveIndex = this.menusx.findIndex(
        m => m.route.name === 'archive'
      )
      this.manualActive(
        winnerArchiveIndex,
        winnerArchiveRoutes.includes(this.$route.name)
      )

      const categoryDetailIndex = this.menusx.findIndex(
        m => m.route.name === 'awards'
      )
      this.manualActive(
        categoryDetailIndex,
        this.$route.name === 'category-detail'
      )

      const newsIndex = this.menusx.findIndex(m => m.route.name === 'news')
      this.manualActive(newsIndex, this.$route.name === 'news-detail')

      this.checkRouuteName()
      this.closeNav()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";

header {
  font-family: var(--button-default-font-family, "DB Adman X");

  .s {
    .menu-btn-s {
      position: fixed;
      z-index: 20;
      right: 0;
      margin: 0px;
      width: 55px;
      height: 55px;
      border: none;
      background-image: url("../../assets/icons/bars-solid.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 50%;
      background-color: $active;
    }

    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 20;
      padding: 0;
      height: 0;
      width: 100vw;
      background-color: black;
      overflow-x: hidden;
      transition: 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

      .box-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: auto;
          height: 42px;
        }

        .close-btn {
          width: 44px;
          height: 44px;
          border: none;
          background-image: url("../../assets/icons/times-solid.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 22px 22px;
          background-color: black;
        }
      }

      .box-link {
        margin-top: 8px;

        .section-link {
          padding-top: 12px;
          padding-bottom: 12px;
          width: 100%;
          height: 100%;
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
          text-align: center;
          font-size: 1.75rem;

          a,
          span {
            color: #808285;
          }

          .router-link-exact-active {
            color: $active;
          }
        }
      }
    }
  }

  .m {
    display: none;
  }
}

.menu-btn-s:focus-visible {
  outline: 3px solid #000000;
  outline-offset: -5px;
}

.close-btn:focus-visible {
  outline: 3px solid $active;
  outline-offset: -3px;
}

.sub-archive-small {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 0 !important;
  border-bottom: 0 !important;

  a {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

.sub-archive-small--open {
  padding-bottom: 8px;
  height: 100% !important;
}

@media only screen and (min-width: 768px) {
  header {
    .s {
      display: none;
    }

    .m {
      position: fixed;
      z-index: 20;
      display: block;
      width: 100vw;
      height: 55px;
      background-color: $light;

      .first {
        display: flex;
        justify-content: space-between;
        height: 100%;

        .left {
          display: flex;
          justify-content: space-between;
          height: 100%;

          .section {
            a,
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              padding-left: 8px;
              padding-right: 8px;
              height: 100%;
              font-size: 1.5rem;
              color: #808285;
            }
          }

          .router-link-exact-active {
            padding-bottom: 3px;
            // padding: 7px 6px;
            border-top: 3px solid red;
          }
        }
      }

      .right {
        transform: translateY(-220px);
        position: absolute;
        top: 0;
        right: 0;
        margin-right: auto;
        padding: 0 12px;
        width: 120px;
        background-color: $active;
        animation: right 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s forwards;

        @media only screen and (min-width: 992px) {
          right: calc(50% - 465px);
        }

        @media only screen and (min-width: 1200px) {
          right: calc(50% - 550px);
        }

        .box-search {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid white;

          input {
            width: 72px;
            border: none;
            background: none;
            font-size: 1.25rem;
            color: white;
          }

          input::placeholder {
            font-size: 1.25rem;
            color: white;
          }

          button {
            background-image: url("../../assets/icons/search-solid.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-color: $active;
          }
        }

        .box-icon {
          display: flex;
          justify-content: center;
          padding: 12px 0;
          border-bottom: 1px solid white;

          img {
            height: 42px;
          }
        }

        .user-btn {
          padding: 12px 0;

          button {
            padding: 8px 0;
            width: 100%;
            background: none;
            font-size: 1.25rem;
            color: white;
          }
        }
      }

      .box-calendar {
        width: 140px;

        .box-search {
          display: flex;
          justify-content: center;

          p {
            font-size: 1.25rem;
            color: white;
          }
        }

        .box-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 6px 0;

          img {
            height: 72px;
          }

          p {
            font-size: 1.25rem;
            color: #ffc107;
          }
        }

        .add-calendar {
          width: 100%;
          height: 52px;
          background: none;
          box-shadow: none !important;

          div {
            position: relative;
            left: -44px;
            top: 4px;
            width: 120px;
            text-align: center;
            font-family: "DB HelvethaicaMon X";
            font-size: 1.5rem;
            color: white;
          }
        }

        .add-calendar:focus {
          outline: none;
        }
      }
    }
  }
}

.sub-archive-medium {
  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  background-color: $active;

  a {
    border-bottom: 1px solid #f1f2f2;
    padding-top: 4px;
    padding-bottom: 4px;
    color: #f1f2f2 !important;
  }

  a:last-child {
    border-bottom: 0;
  }
}

@keyframes right {
  0% {
    transform: translateY(-220px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
